import { Flow_0_0_2, getFullItemOne } from '@flexus/core';
import { map, skipWhile } from 'rxjs/operators';
import { CollapseActionPanel, setActionPanelItems } from '../../../../app-shell-features';

export const BET_220: Flow_0_0_2 = {
	id: '220',
	name: 'create_manual_settlement_letter',
	itemType: 'flow',
	header: {
		title: (store, bf) => {
			return store.select(getFullItemOne).pipe(
				skipWhile((itemOne: any) => {
					return itemOne === null || itemOne === undefined;
				}),
				map(itemOne => {
					if (itemOne) {
						return `Create Manual Settlement Letter : ${itemOne?.loan_information?.mavenclaimnumber} - ${itemOne?.applicant?.surname}`;
					} else {
						return 'Create Manual Settlement Letter';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	onStateInit: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	onStateDestroy: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	actionPanel: instance => setActionPanelItems(instance, ['call-logs', 'claim-card', 'documents', 'time-stamp'], { filesFunctionName: 'getAllClaimFiles' }),
	instructions: {
		editRoles: {
			0: 'Create Manual Settlement Letter'
		},
		viewRoles: {
			0: 'Create Manual Settlement Letter'
		}
	},
	startNode: 'NoInvoiceDetails',
	nodes: {
		NoInvoiceDetails: {
			component: 'FLXHeadingWithInstructionsComponent',
			name: 'Create Manual Settlement Letter',
			inputs: {
				title: 'Create Manual Settlement Letter',
				headingConfig: { size: 'medium', weight: 'normal' },
				instructions: ['4-Sure to generate Settlement Letter to send to customer to be signed']
			},
			serverCalls: {},
			initFormFields: bf => {
				bf.patchValues({ new_state: 221 });
			},
			navs: [
				{
					text: 'Letter Sent',
					nextNode: 'SubmissionSuccess',
					color: 'primary',
					serverFirst: true,
					optIntoValidation: true,
					serverCalls: {
						response: {
							serviceVariable: 'betSpService',
							functionName: 'updateJob',
							errorMessage: 'Job could not be updated!'
						}
					}
				}
			]
		},
		//submission Nodes ************
		SubmissionSuccess: {
			component: 'FLXSuccessTickComponent',
			navs: []
		}
	},

	bigFormToStoreMapper: {
		new_state: 'new_state'
	}
};
